import { useDispatch, useSelector } from "react-redux";
import { categoryActions } from "../../../store/category-slice";
import { useHistory } from "react-router-dom";
import getAll from "../../../resources/images/app/banner_background.png";
import { basics } from "../../../basics";

export const ShowSpecialsHandler = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const typeOfProductsCategories = useSelector(
    (state: any) => state.category.typeOfProductsCategories
  );
  const isActive = typeOfProductsCategories === "special";
  const showSpecialsHandler = () => {
    dispatch(categoryActions.newCategoryIsSelected());
    dispatch(categoryActions.typeOfProductsCategoriesChanger("special"));
    // dispatch(fetchShowSpecialsHandler(currentPage, itemsPerPage));
    history.push("/products");
  };
  return (
    <div
      onClick={showSpecialsHandler}
      className={`flex flex-col items-center justify-center gap-1 sm:gap-1.5 w-full h-24 sm:h-32 rounded-2xl cursor-pointer p-1 sm:p-2.5 border transition ${
        isActive
          ? "bg-orange-50 border-orange-200 shadow-sm"
          : "bg-white border-slate-100 hover:border-emerald-200 hover:bg-emerald-50/40 hover:shadow-sm"
      }`}
    >
      <img
        src={getAll}
        alt={basics.specialOrderTitle}
        className="h-9 w-9 sm:h-12 sm:w-12 rounded-full object-cover"
      />
      <p
        className="text-[11px] sm:text-xs font-semibold text-gray-900 text-center leading-4 sm:leading-5"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {basics.specialOrderTitle}
      </p>
    </div>
  );
};

export const ShowAllsHandler = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const typeOfProductsCategories = useSelector(
    (state: any) => state.category.typeOfProductsCategories
  );
  const isActive = typeOfProductsCategories === "allProducts";
  const showAllsHandler = () => {
    dispatch(categoryActions.newCategoryIsSelected());
    dispatch(categoryActions.typeOfProductsCategoriesChanger("allProducts"));
    // dispatch(fetchShowAllProductsHandler(currentPage, itemsPerPage));
    // console.log('r(currentPage',currentPage);
    history.push("/products");
  };
  return (
    <div
      onClick={showAllsHandler}
      className={`flex flex-col items-center justify-center gap-1 sm:gap-1.5 w-full h-24 sm:h-32 rounded-2xl cursor-pointer p-1 sm:p-2.5 border transition ${
        isActive
          ? "bg-orange-50 border-orange-200 shadow-sm"
          : "bg-white border-slate-100 hover:border-emerald-200 hover:bg-emerald-50/40 hover:shadow-sm"
      }`}
    >
      <img
        src={getAll}
        alt={basics.getAll}
        className="h-9 w-9 sm:h-12 sm:w-12 rounded-full object-cover"
      />
      <p
        className="text-[11px] sm:text-xs font-semibold text-gray-900 text-center leading-4 sm:leading-5"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {basics.getAll}
      </p>
    </div>
  );
};
